import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .ant-row {
    label {
      display: inline-block;
      margin-top: 8px;
      margin-bottom: 8px;
      font-family: "Asap", sans-serif;
      color: #9074bf;
      font-size: 14px;
      font-weight: bold;
    }
  }

  .error {
    color: #d44c4c !important;
  }
`;

export const Body = styled.div`
  width: 100%;
  padding: 0px 24px;
  min-height: -moz-calc(100vh - 165px);
  min-height: -webkit-calc(100vh - 165px);
  min-height: calc(100vh - 165px);
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button:first-of-type {
      margin-right: 12px !important;
    }
  }
`;

export const ResultPanel = styled.div`
  width: 100%;
  margin-top: 8px;
  padding: 12px 16px;
  background: #f5f5f5;
  border-radius: 4px;

  .resultItem {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;

    span.label {
      font-family: "Asap", sans-serif;
      font-size: 12px;
      color: #8a50a5;
      font-weight: bold;
    }

    span.value {
      font-family: "Asap", sans-serif;
      font-size: 16px;
      color: #4b4b4b;
    }
  }
`;

export const SectionTitle = styled.div`
  width: 100%;
  margin-top: 16px;
  font-family: "Asap", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #591f74;
`;
